<template>
    <v-card stretch>
        <div v-padding="3">
            <v-form @submit="handleSubmit" :validate="validate" :readonly="isSearching || isFetchingBalances">
                <template scope="api">
                    <v-row align-items="end">
                        <v-col xs="8">
                            <v-form-input
                                field="inn"
                                label="Введите ИНН или название организации"
                            />
                        </v-col>
                        <v-col xs="4">
                            <v-button type="submit" flat primary :disabled="api.isInvalid || isSearching || isFetchingBalances">
                                найти
                            </v-button>
                        </v-col>
                    </v-row>
                    <v-animation-height>
                        <v-row v-if="api.getTouched('inn') && api.getError('isInn')">
                            <v-col>
                                <v-text type="caption" error>{{ api.getError('isInn') }}</v-text>
                            </v-col>
                        </v-row>
                    </v-animation-height>
                    <v-row v-margin.top="1">
                        <v-col xs="8">
                            <v-text type="caption">
                                Поиск по названию компании может осуществляться долго, до 10 минут.<br>
                                Рекомендуем использовать для запроса ИНН.
                            </v-text>
                        </v-col>
                    </v-row>
                </template>
            </v-form>

            <company-details v-if="isShowCompanyDetails" :on-create="onCreate" :company="company" :total="total" />
        </div>

        <request-table-inns v-if="isShowTable" v-model="selectedEntity">
            <v-spinner :active="isFetchingBalances">
                <v-button primary :disabled="!selectedEntity || isFetchingBalances" @click="handleFetchBalances()">
                    проверить наличие балансов
                </v-button>
            </v-spinner>
        </request-table-inns>
    </v-card>
</template>

<script>
    import { validate, isRequired, isInn } from '../../../services/validator';
    import { RequestTableInns } from '../requestTableInns';
    import CompanyDetails from './CompanyDetails';

    export default {
        name: 'request-balance',
        components: {
            RequestTableInns,
            CompanyDetails,
        },
        props: {
            onCreate: Function,
            onSearchCompanies: Function,
            onFetchCompanyDetails: Function,
            company: {
                type: Object,
                default() {
                    return {};
                }
            },
            total: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                selectedEntity: undefined,
                isFetchingBalances: false,
                isShowTable: false,
                isShowCompanyDetails: false,
                isSearching: false,
            }
        },
        methods: {
            validate(values) {
                return validate(values, {
                    shadowInn: [() => isRequired(values.inn)],
                    isInn: [
                        () => values.inn && /^\d+$/.test(values.inn.toString().trim())
                            ? isInn(values.inn)
                            : undefined,

                    ],
                });
            },

            handleFetchCompanies(name) {
                if (this.isSearching) {
                    return;
                }

                this.selectedEntity = undefined;
                this.isSearching = true;
                this.isShowTable = true;
                this.isShowCompanyDetails = false;

                this.onSearchCompanies(name)
                    .then(() => {
                        this.isSearching = false;
                    })
                    .catch(() => {
                        this.isSearching = false;
                    });
            },

            handleSubmit({ inn }) {
                const trimmedInn = inn.toString().trim();
                if (/^\d+$/.test(trimmedInn)) {
                    this.handleFetchBalances(trimmedInn);
                } else {
                    this.handleFetchCompanies(trimmedInn);
                }
            },

            handleFetchBalances(inn) {
                if (this.isFetchingBalances) {
                    return;
                }

                this.isFetchingBalances = true;

                this.onFetchCompanyDetails(inn || this.selectedEntity.inn)
                    .then(() => {
                        this.isFetchingBalances = false;
                        this.isShowTable = false;
                        this.isShowCompanyDetails = true;
                    })
                    .catch(() => {
                        this.isFetchingBalances = false;
                        this.isShowTable = false;
                        this.isShowCompanyDetails = true;
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// RequestBalance.vue?6d477154